// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import Button from '@mui/material/Button'
import CircularProgress from '@mui/material/CircularProgress'
import TextField from '@mui/material/TextField'
import React from 'react'
import { Mutation } from 'react-apollo'
import { fetchDailyManagement } from '../../dailyManagement/dailyManagementQueries'
import { i18n } from '../../index'
import { fetchDashboardStats } from '../../OldDashboard/oldDashboardQueries'
import CustomPriceDialog from './CustomPriceDialog'
import css from './IncentivesPanel.css'
import { getStaffingPlan, increaseSalesIncentiveProduct } from './incentivesPanelQueries'
import type { StaffingPlanVariables } from './types'
type Props = {
  label?: string | null
  variables: StaffingPlanVariables
  index?: number
  registerIncentiveSale: (...args: Array<any>) => any
  salesIncentiveProductId?: string
  stationId: string
  date: string
  isPcs: boolean
  price?: number
  innerTxt?: string
  category: string
}
type State = {
  customProductName: string
  euros: string
  disabled: boolean
  cents: string
  isDialogOpen: boolean
}

class AddIncentiveButton extends React.Component<Props, State> {
  state = {
    customProductName: '',
    euros: '',
    cents: '',
    disabled: this.props.tag === 'custom-product' || this.props.tag === 'custom-price',
    isDialogOpen: false,
  }
  openDialog = () => {
    this.setState({
      isDialogOpen: true,
    })
  }
  closeDialog = () => {
    this.setState({
      isDialogOpen: false,
      data: null,
    })
  }
  onEdit = (data: ChecklistItem) => {
    this.setState({
      data,
    })
    this.openDialog()
  }

  amountInEuros(cents: string, euros: string) {
    // verify value inputs first
    if (cents.includes('-') || cents.length > 2 || (euros.includes('-') ? euros.length > 4 : euros.length > 3)) {
      return 0
    }

    let roundedCents = ''

    if (cents.length === 0) {
      roundedCents = '00'
    } else if (cents.length === 1) {
      roundedCents = `0${cents}`
    } else {
      roundedCents = cents
    }

    return parseFloat(`${euros}.${roundedCents}`)
  }

  handleClick = (onMutate: (...args: Array<any>) => any) => {
    const { registerIncentiveSale, salesIncentiveProductId, tag, label, price, isPcs } = this.props
    const { euros, cents } = this.state
    const isCustomProduct = tag === 'custom-product'
    const isCustomPrice = tag === 'custom-price'
    const isFixedPrice = typeof price === 'number' && !isPcs
    const isEuroSale = isCustomPrice || isFixedPrice
    const amountInEuros = this.amountInEuros(cents, euros)
    const amount = isEuroSale ? (isCustomPrice ? amountInEuros : price) : 1
    registerIncentiveSale(onMutate, salesIncentiveProductId, label, amount)
    //Reset input field value and button state
    this.setState({
      customProductName: '',
      disabled: isCustomProduct || isCustomPrice,
      cents: '',
      euros: '',
    })
  }
  handleCustomName = (e: React.SyntheticEvent<EventTarget>) => {
    this.setState({
      customProductName: e.target.value,
      disabled: e.target.value === '',
    })
  }
  handleEuroSale = (value: any, type: string) => {
    this.setState(
      {
        [type]: value,
      },
      this.handleButtonState,
    )
  }
  handleButtonState = () => {
    const { euros, cents } = this.state
    const disableSubmit = this.amountInEuros(cents, euros) === 0
    this.setState({
      disabled: disableSubmit,
    })
  }
  handleKeyPress = (onMutate: (...args: Array<any>) => any, e: React.KeyboardEvent<EventTarget>) => {
    const { customProductName } = this.state

    if (e.key === 'Enter' && customProductName !== '') {
      this.handleClick(onMutate)
    }
  }

  render() {
    const { label, variables, tag, stationId, innerTxt, category, registerIncentiveSale, date } = this.props
    const { customProductName, disabled, isDialogOpen } = this.state
    const isCustomProduct = 'custom-product' === tag
    const isCustomPrice = 'custom-price' === tag
    let color

    switch (category) {
      case 'Hesburger':
        color = '#37acff'
        break

      case 'Market':
        color = '#c49c5a'
        break

      case 'Ravintola':
        color = '#ff6820'
        break

      default:
        color = '#78a22f'
        break
    }

    return (
      <Mutation
        mutation={increaseSalesIncentiveProduct}
        refetchQueries={() => [
          {
            query: getStaffingPlan,
            variables,
            skip: !variables || !variables.stationId || !variables.date,
          },
          {
            query: fetchDashboardStats,
            variables: {
              stationId,
            },
          },
          {
            query: fetchDailyManagement,
            variables: {
              stationId,
              date: date,
              mode: 'Day',
              status: 'InProgress',
            },
          },
        ]}
      >
        {(onMutate, { loading }) => (
          <div className={css.incentiveItemContainer}>
            {!isCustomPrice && (
              <Button
                className={css.addButton}
                variant='contained'
                color='primary'
                onClick={() => this.handleClick(onMutate)}
                disabled={disabled || loading}
                style={{
                  backgroundColor: color,
                }}
              >
                {loading ? (
                  <CircularProgress />
                ) : (
                  <span>{label && label.trim() !== '' ? label : `+${innerTxt ? innerTxt : ''}`}</span>
                )}
              </Button>
            )}
            {isCustomProduct && (
              <TextField
                className={css.customProduct}
                id='custom-product'
                label={i18n.t('employeeCard.customProduct')}
                type='text'
                value={customProductName}
                onChange={this.handleCustomName}
                onKeyPress={(e) => this.handleKeyPress(onMutate, e)}
              />
            )}
            {isCustomPrice && (
              <Button
                className={css.addButton}
                variant='contained'
                color='primary'
                onClick={() => this.openDialog()}
                style={{
                  backgroundColor: color,
                }}
              >
                <span>{label && label.trim() !== '' ? label : innerTxt}</span>
              </Button>
            )}

            <CustomPriceDialog
              isOpen={isDialogOpen}
              onClose={this.closeDialog}
              registerIncentiveSale={registerIncentiveSale}
              salesIncentiveProductId={this.props.salesIncentiveProductId}
              variables={variables}
              stationId={stationId}
              date={date}
            />
          </div>
        )}
      </Mutation>
    )
  }
}

export default AddIncentiveButton
